import template from './addSecurities.html';
import controller from './addSecurities.controller';

export const addSecuritiesComponent = {
  name: 'addSecuritiesComponent',
  restrict: 'E',
  bindings: {
    modalInstance: '<'
  },
  template,
  controller,
  controllerAs: 'vm',
};



// WEBPACK FOOTER //
// ./src/app/common/ui/addSecurities/addSecurities.component.js